import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Form, FormGroup, Label } from 'reactstrap';
import { Utils } from '../../../services';
import { JsonEditorField, PageTitle, CronTaskMethodField, CronTaskFrequencyField, HelpTooltips } from '../../../components';
import { loadTickettypes, updateCronTask, addBucket } from '../../../redux';
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/fr';
import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css'

moment.locale('fr');
momentLocalizer();

let CronTaskForm = ({ isCreation, handleSubmit, submitting, cron_task }) => {
    const { t }         = useTranslation();
    const dispatch      = useDispatch();
    const { isLoadingOne } = useSelector(state => state.cron_tasks);

    const [showTable, setShowTable] = useState(true);

    useEffect(() => {
        dispatch(loadTickettypes());
    }, []);

    const updateBucketOrder = (buckets) => {
        dispatch(updateCronTask({ ...cron_task, buckets }));
    }

    const add = () => {
        dispatch(addBucket());
    }

    const remove = (_id) => {
        dispatch(updateCronTask({
            ...cron_task,
            buckets: cron_task.buckets.filter(b => b._id !== _id)
        }));
    }

    const currency = Utils.currency()

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle><i className="fa fa-info-circle"></i>&nbsp;{t("cron_tasks.informations")}</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col sm={12} lg={6}>
                                        <FormGroup row >
                                            <Label for="name" sm={3}>{t("cron_tasks.name")}</Label>
                                            <Col sm={9}>
                                                <Field data-tip data-for='nametip' required component="input" className="form-control" type="text" name="name" id="name" autoComplete="name" placeholder={t("cron_tasks.name_placeholder")} />
                                                <HelpTooltips id='nameTip' value='name' />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12} lg={6}>
                                        <FormGroup row>
                                            <Label for="_id" sm={3} className="text-right" >{t("cron_tasks._id")}</Label>
                                            <Col sm={9} data-tip data-for='tktIdTip'>
                                                <Field
                                                    component="input"
                                                    className="form-control"
                                                    type="text"
                                                    name="_id"
                                                    id="_id"
                                                    autoComplete="_id"
                                                    disabled
                                                    placeholder={t("cron_tasks._id")}
                                                />
                                            </Col>
                                            <HelpTooltips id='tktIdTip' value='tkt_id' />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle><i className="fa fa-plug"></i>&nbsp;{t("cron_tasks.request")}</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col sm={12} lg={6}>
                                        <FormGroup row >
                                            <Label for="url" sm={3}>{t("cron_tasks.url")}</Label>
                                            <Col sm={9}>
                                                <Field data-tip data-for='urltip' required component="input" className="form-control" type="url" name="url" id="url" autoComplete="url" placeholder={t("cron_tasks.url_placeholder")} />
                                                <HelpTooltips id='urlTip' value='url' />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12} lg={6}>
                                        <FormGroup row >
                                            <Label for="method" sm={3}>{t("cron_tasks.method")}</Label>
                                            <Col sm={9}>
                                                <CronTaskMethodField name="method" required />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} lg={6}>
                                        <FormGroup row >
                                            <Label for="body" sm={3}>{t("cron_tasks.headers")}</Label>
                                            <Col sm={9}>
                                                <Field component={JsonEditorField} name="headers" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                    {cron_task?.acceptsBody() && (
                                        <Col sm={12} lg={6}>
                                            <FormGroup row >
                                                <Label for="body" sm={3}>{t("cron_tasks.body")}</Label>
                                                <Col sm={9}>
                                                    <Field component={JsonEditorField} name="body" />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    )}
                                </Row>
                                {!isCreation && (
                                    <Row>
                                        <Col sm={12} lg={6}>
                                            <FormGroup row >
                                                <Label for="timeout" sm={3}>{t("cron_tasks.timeout")}</Label>
                                                <Col sm={9}>
                                                    <Field
                                                        data-tip data-for='timeouttip'
                                                        required
                                                        component="input"
                                                        className="form-control"
                                                        type="number"
                                                        name="timeout"
                                                        min={1}
                                                        max={3600}
                                                        autoComplete="timeout"
                                                        placeholder={t("cron_tasks.timeout_placeholder")}
                                                    />
                                                    <HelpTooltips id='timeoutTip' value='timeout' />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                )}
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle><i className="fa fa-clock-o"></i>&nbsp;{t("cron_tasks.frequency")}</CardTitle>
                            <CardText tag="div">
                                <FormGroup row >
                                    <Col sm={12}>
                                        <CronTaskFrequencyField name="frequency" required />
                                    </Col>
                                </FormGroup>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <br />
                    <ButtonGroup>
                        <Button type="submit" color="success" disabled={submitting || isLoadingOne}>
                            {isLoadingOne ?
                                <span>
                                    &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                </span>
                                :
                                <span>
                                    <i className="fa fa-save"></i>&nbsp;
                                    {t("common.save")}
                                </span>
                            }
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
        </Form>
    );
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
CronTaskForm = reduxForm({
    form: 'cron_taskForm', // a unique identifier for this form
    enableReinitialize: true,
    destroyOnUnmount: false
})(CronTaskForm)

// You have to connect() to any reducers that you wish to connect to yourself
CronTaskForm = connect(
    state => ({
        initialValues: state.cron_tasks.cron_task, // pull initial values from cron_tasks reducer
        cron_tasks: state.cron_tasks,
    }), {}
)(CronTaskForm)

export default CronTaskForm;
